import { MARQUEE_WORDS } from "../data/siteContent";

export default function MarqueeBand({ embedded = false }) {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];

  return (
    <div
      className={
        embedded
          ? "relative z-10 w-full border-t border-white/10 bg-ink/75 py-4 backdrop-blur-md"
          : "relative border-y border-white/10 bg-ink-soft/90 py-4 backdrop-blur-md"
      }
      aria-hidden
    >
      <div className="flex overflow-hidden">
        <div className="flex min-w-max animate-marquee items-center gap-10 whitespace-nowrap sm:gap-12">
          {items.map((word, i) => (
            <span key={`${word}-${i}`} className="flex items-center gap-10 sm:gap-12">
              <span className="font-sans text-xl font-semibold italic text-white/90 sm:text-2xl lg:text-3xl">
                {word}
              </span>
              <span className="h-2 w-2 rotate-45 bg-gradient-to-br from-violet-400 via-accent to-fuchsia-400 shadow-[0_0_8px_rgba(139,92,246,0.8)]" />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
